import { render, staticRenderFns } from "./index.vue?vue&type=template&id=51671c88&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=51671c88&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51671c88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51671c88')) {
      api.createRecord('51671c88', component.options)
    } else {
      api.reload('51671c88', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=51671c88&scoped=true", function () {
      api.rerender('51671c88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superInviter/index.vue"
export default component.exports